import React from "react";

import moment from "moment";
import { Provider } from "react-redux";
import { Normalize } from "styled-normalize";
import { ThemeProvider } from "styled-components";
import { ConfigProvider } from "antd";
import ruRU from "antd/lib/locale/ru_RU";
import "moment/locale/ru";
import App from "App";
import reportWebVitals from "./reportWebVitals";
import theme from "./theme";
import GlobalStyle from "components/GlobalStyle/GlobalStyle";
import { store } from "store/store";
import ErrorFallback from "./components/ErrorFallback/ErrorFallback";
import { ErrorBoundary } from "react-error-boundary";
import { DragContextProvider } from "components/drag";
import { Toaster } from "sonner";
import { ClearAllToastsButton } from "utils/Notifications/ClearAllToastsButton";
import { createRoot } from 'react-dom/client';
moment.locale("ru");

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            {/* <PersistGate loading={null} persistor={persistor}> */}
            <ConfigProvider locale={ruRU}>
                <div style={{ position: "relative" }}>
                    <Toaster
                        position="top-right"
                        visibleToasts={8}
                        expand={false}
                        closeButton={true}
                        className="my-toaster-container"
                        offset="36px"
                        toastOptions={{
                            style: {
                                fontSize: "14px",
                                padding: "12px 16px",
                                borderRadius: "8px",
                                minWidth: "300px",
                                color: "rgba(0, 0, 0, 0.88)",
                                background: "white",
                                boxShadow:
                                    "0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)",
                            },
                        }}
                    />

                    <ClearAllToastsButton />
                </div>
                <DragContextProvider>
                    <ThemeProvider theme={theme}>
                        <GlobalStyle />
                        <Normalize />
                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                            <App />
                        </ErrorBoundary>
                    </ThemeProvider>
                </DragContextProvider>
            </ConfigProvider>
            {/* </PersistGate> */}
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
